<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/logo/logo-black.png"></navbar>
      <div class="st-FixedPoint"></div>
      <div class="st-MainContainer">
        <main class="st-MainContents" style="padding-top: 120px;">

          <nav class="series-Nav sw-stickyTrigger-target">
            <div class="series-Nav_Inner series-Nav_Inner_company">
              <ul class="mb-0">
                <li class="current">
                  <router-link to="/solution/logistics-automation">
                    <img style="object-fit: cover;" height="50" width="50" src="../../../../static/img/home/menu-logistics-automation.jpg" alt="">
                    <h4 class="pl-md-4">ロボティクス自動化ソリューション
                    </h4>
                    <!-- <h4 class="pl-4 pl-md-5 show-sp">
                    </h4> -->
                  </router-link>
                </li>
                <li>
                  <router-link to="/solution/low-code">
                    <img style="object-fit: cover;" height="50" width="50" src="../../../../static/img/home/menu-low-code.jpg" alt="">
                    <h4 class="pl-3 pl-md-4">Lowコードソリューション
                    </h4>
                    <!-- <h4 class="pl-4 pl-md-5 show-sp">
                      ES-FAST
                    </h4> -->
                  </router-link>
                </li>
              </ul>
            </div>
          </nav>

          <header class="series-PageTitle">
            <div class="series-PageTitle_Inner" data-appear>
              <h1>
                <span class="series-PageTitle_Logo"></span>
                <span class="series-PageTitle_Title" style="color:#FFF">ロボティクス自動化ソリューション</span>
              </h1>
              <div class="sw-parallax">
                <div class="sw-parallax_outer js-parallax_outer">
                  <div class="sw-parallax_inner">
                    <div class="sw-parallax_block js-parallax_block">
                      <div class="sw-parallax_target promotion-PageTitle-visual" style="background: url(../../../../static/img/solution/logistics-automation/top.jpg) 50%/cover no-repeat;top: 70px;height: 480px;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <section class="company-Profile">
            <div class="company-Profile_Inner">
              <div class="st-Grid_Inner p-0 solution-logistics-automation-appear-1" data-appear="true">
                <h2 class="common-text-appear text-center solution-logistics-automation-appear-2" data-appear="true">
                  <span class="sw-Section_Header-en pb-3">
                    <b>
                      <font>
                        <font>ロボティクス自動化ソリューション</font>
                      </font>
                    </b>
                  </span>
                </h2>
              </div>

              <div class="fast-detail-body">
                <div class="col-12 px-0">
                  <div class="content-wrapper-home-fast st-grid-padding">
                    <div class="common-image-appear solution-logistics-automation-appear-3" data-appear="true">
                      <picture class="text-center pt-5">
                        <div class="show-pc"><img width="100%" src="../../../../static/img/solution/logistics-automation/05.jpg" /></div>
                        <div class="show-sp"><img width="100%" src="../../../../static/img/solution/logistics-automation/05.jpg" /></div>
                      </picture>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </main>
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList">
            <li class="st-BreadcrumbsList_Item">
              <router-link class="st-BreadcrumbsList_Item-link" to="/">
                <p itemprop="item" aria-current="page"><span itemprop="name">ホーム</span></p>
              </router-link>
            </li>
            <li class="st-BreadcrumbsList_Item">
              <p itemprop="item" aria-current="page"><span itemprop="name">ロボティクス自動化ソリューション</span></p>
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'
import Swiper from 'swiper/swiper-bundle.js'
import 'swiper/swiper-bundle.css'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
      wrapperHomeFastList: [
        { id: 1, imgSrc: '../../../../static/img/home/fast/fast01.png' },
        { id: 2, imgSrc: '../../../../static/img/home/fast/fast02.png' },
        { id: 3, imgSrc: '../../../../static/img/home/fast/fast03.png' },
        { id: 4, imgSrc: '../../../../static/img/home/fast/fast04.png' },
        { id: 5, imgSrc: '../../../../static/img/home/fast/fast05.png' },
        { id: 6, imgSrc: '../../../../static/img/home/fast/fast06.png' },
      ],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {

      new Swiper('.swiper-container-home-fast-1', {
        pagination: {
          el: '.swiper-pagination-fast',
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        },
        loop: true,
        autoplay: true,
      })

      new Swiper('.swiper-container-home-fast-2', {
        pagination: {
          el: '.swiper-pagination-fast-2',
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        },
        loop: true,
        autoplay: true,
      })

      new Swiper('.swiper-container-home-fast-slide-1', {
        slidesPerView: 'auto',
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 45
          }
        },
        navigation: {
          nextEl: '.swiper-container-home-fast-slide-1-next',
          prevEl: '.swiper-container-home-fast-slide-1-prev'
        },
      })

      $(".series-PageTitle_Inner").eq(0).addClass('appear')
      $('.solution-logistics-automation-appear-1').addClass('st-Grid_Inner_appear')
      $('.solution-logistics-automation-appear-2').addClass('appear')
      $('.solution-logistics-automation-appear-3').addClass('appear')
      // element.offsetHeight
      let beforeScollH = 0
      $(document).scroll(() => {

        if (this.$route.path != '/solution/logistics-automation') {
          return false
        }

        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        let differH = scroH - beforeScollH
        let mql = window.matchMedia('(max-width:768px)')

        if (differH === 0) {
          return false
        }
        beforeScollH = scroH

        if (scroH > 50) {
          $('.st-Header').addClass('isStickyReverse')
          $('.series-Nav').addClass('series-Nav-display')
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.series-Nav').removeClass('series-Nav-display')
          $('.st-Header').removeClass('isStickyReverse')
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (differH > 0) {
          $('.series-Nav').removeClass('series-Nav-display')
          if (scroH > 50 && !$('.st-Hd_Trigger').hasClass('is-active')) {
            $('.st-Header').addClass('isStickyReverse')
            $('.header').css({ 'display': 'none' })
          }
          if (mql.matches) {
            $('.series-Nav').css({ 'padding-top': '0px' })
          }
        } else {
          $('.st-Header').removeClass('isStickyReverse')

          if (scroH > 50) {
            $('.series-Nav').addClass('series-Nav-display')
            if (mql.matches) {
              $('.series-Nav').css({ 'padding-top': '18px' })
            }
          } else {
            if (mql.matches) {
              $('.series-Nav').css({ 'padding-top': '0px' })
            }
          }

          $('.header').css({ 'display': 'block' })
        }

        if (viewW > 769) {

          if (scroH > 300) {
            $('.series-PageTitle_Inner').eq(0).removeClass('appear')
          } else {
            $('.series-PageTitle_Inner').eq(0).addClass('appear')
          }

          if (scroH > 750) {
            $('.solution-logistics-automation-appear-1').removeClass('st-Grid_Inner_appear')
            $('.solution-logistics-automation-appear-2').removeClass('appear')
          } else {
            $('.solution-logistics-automation-appear-1').addClass('st-Grid_Inner_appear')
            $('.solution-logistics-automation-appear-2').addClass('appear')
          }
        } else {
          $('.solution-logistics-automation-appear-1').addClass('st-Grid_Inner_appear')
          $('.solution-logistics-automation-appear-2').addClass('appear')
          $('.solution-logistics-automation-appear-3').addClass('appear')
        }
      })
    }
  }
}
</script>
<style scoped src="../../../../static/css/solution.css">
</style>




// WEBPACK FOOTER //
// src/components/pages/solution/logistics-automation.vue